var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('div',{class:_vm.classDec,on:{"click":_vm.decrease}},[_vm._v("ー")]),_c('div',{class:_vm.classNum},[_vm._v(_vm._s(_vm.count))]),_c('div',{class:_vm.classInc,on:{"click":_vm.increase}},[_vm._v("+")])])
}
var staticRenderFns = []

export { render, staticRenderFns }